import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Shield, Check } from 'lucide-react';

const BestAIHumanizer = () => {
  const tools = [
    { name: 'Penocio', rating: 9.5, price: 'R359/mo', words: '50,000', highlight: true },
    { name: 'Lunchbreak AI', rating: 7.2, price: '$19.99/mo', words: '15,000' },
    { name: 'Undetectable AI', rating: 8.1, price: '$24.99/mo', words: '30,000' },
    { name: 'HumanizeAI', rating: 7.8, price: '$29.99/mo', words: '40,000' }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 py-24">
        <div className="container mx-auto max-w-5xl">
          <div className="text-center mb-16">
            <Badge className="mb-4" variant="secondary">Comparison Guide</Badge>
            <h1 className="text-4xl md:text-5xl font-heading font-black tracking-tighter mb-6">
              Best AI Humanizer Tools in 2026
            </h1>
            <p className="text-lg text-muted-foreground">
              We tested 12+ AI humanizers to find which ones actually work.
            </p>
          </div>

          <div className="space-y-6">
            {tools.map((tool, index) => (
              <Card key={tool.name} className={`p-8 border-2 ${tool.highlight ? 'border-primary' : 'border-zinc-200'}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h2 className="text-2xl font-heading font-bold">{index + 1}. {tool.name}</h2>
                      {tool.highlight && <Badge>Best Overall</Badge>}
                    </div>
                    <div className="flex items-center gap-6 text-sm text-muted-foreground mb-4">
                      <span>Rating: <span className="font-bold text-foreground">{tool.rating}/10</span></span>
                      <span>Price: <span className="font-bold text-foreground">{tool.price}</span></span>
                      <span>Words: <span className="font-bold text-foreground">{tool.words}/mo</span></span>
                    </div>
                    {tool.highlight && (
                      <div className="space-y-2 mb-4">
                        <p className="flex items-center gap-2 text-sm">
                          <Check className="h-4 w-4 text-accent" />
                          Highest success rate against all detectors
                        </p>
                        <p className="flex items-center gap-2 text-sm">
                          <Check className="h-4 w-4 text-accent" />
                          Best value for word count
                        </p>
                        <p className="flex items-center gap-2 text-sm">
                          <Check className="h-4 w-4 text-accent" />
                          Real free tier, no credit card required
                        </p>
                      </div>
                    )}
                  </div>
                  {tool.highlight && (
                    <Link to="/">
                      <Button>Try Free</Button>
                    </Link>
                  )}
                </div>
              </Card>
            ))}
          </div>

          <Card className="mt-12 p-12 text-center bg-secondary border-zinc-200">
            <Shield className="h-16 w-16 mx-auto mb-4 text-primary" />
            <h2 className="text-3xl font-heading font-bold mb-4">Try the #1 AI Humanizer Free</h2>
            <p className="text-muted-foreground mb-6">Start with 5,000 words. No credit card required.</p>
            <Link to="/">
              <Button size="lg">Get Started Free</Button>
            </Link>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BestAIHumanizer;
